(() => {
  const fallback = document.getElementById('mr-chat-contact-fallback');
  if (!fallback || !window.customElements) return;

  const watched = new WeakSet();
  const observeRuntime = (runtime) => {
    const root = runtime.shadowRoot;
    if (!root || watched.has(runtime)) return;
    watched.add(runtime);
    let attempts = 0;
    let timer;
    let ready = false;

    const inspect = () => {
      const panel = root.querySelector('.panel');
      if (!panel) return;
      if (runtime.hasAttribute('shell-ready')) ready = true;
      const unavailable = panel.classList.contains('panel--unavailable');
      const retry = panel.querySelector('.panel__unavailable-retry');
      if (!unavailable || !runtime.hasAttribute('open')) {
        clearTimeout(timer);
        timer = undefined;
        return;
      }

      const message = panel.querySelector('.panel__unavailable');
      if (message && !message.querySelector('.mr-chat-contact-fallback')) {
        const content = fallback.content.cloneNode(true);
        const style = document.createElement('style');
        style.textContent = '.mr-chat-contact-fallback{margin-top:24px;font-size:16px;line-height:1.5;text-align:center}.mr-chat-contact-fallback p{margin:0 0 8px}.mr-chat-contact-fallback a{display:block;padding:12px 16px;margin:8px 0;color:inherit;border:1px solid currentColor;border-radius:8px;text-decoration:underline;min-height:44px;box-sizing:border-box}.mr-chat-contact-fallback a:focus-visible{outline:2px solid currentColor;outline-offset:3px}';
        content.append(style);
        message.append(content);
      }

      if (ready || !retry || retry.disabled || attempts >= 2 || timer ||
          !navigator.onLine || document.visibilityState !== 'visible') return;
      timer = setTimeout(() => {
        timer = undefined;
        if (ready || !runtime.isConnected || !runtime.hasAttribute('open') ||
            document.visibilityState !== 'visible' || !navigator.onLine ||
            !panel.classList.contains('panel--unavailable') || retry.disabled) return;
        attempts += 1;
        runtime.dataset.mrRecoveryAttempts = String(attempts);
        retry.click();
      }, attempts === 0 ? 250 : 1000);
    };

    const observer = new MutationObserver(inspect);
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden']});
    observer.observe(runtime, {attributes: true, attributeFilter: ['open', 'shell-ready']});
    window.addEventListener('online', inspect);
    document.addEventListener('visibilitychange', inspect);
    inspect();
  };

  customElements.whenDefined('shopify-chat').then(() => {
    const chat = document.querySelector('shopify-chat');
    if (!chat?.shadowRoot) return;
    const findRuntime = () => {
      chat.shadowRoot.querySelectorAll('shopify-agent-runtime').forEach(observeRuntime);
    };
    customElements.whenDefined('shopify-agent-runtime').then(findRuntime);
    new MutationObserver(findRuntime).observe(chat.shadowRoot, {childList: true, subtree: true});
    findRuntime();
  });
})();
